export default "__VITE_ASSET__5Om77r8U__"